import { render, staticRenderFns } from "./HospitalReportForm.vue?vue&type=template&id=d5ca6c4c&"
import script from "./HospitalReportForm.vue?vue&type=script&lang=js&"
export * from "./HospitalReportForm.vue?vue&type=script&lang=js&"
import style0 from "./HospitalReportForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports